"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CardResultsTable_1 = __importDefault(require("@Components/CardResultsTable"));
require("../index.scss");
const ExtendedOrCompactCardResults = (props) => {
    const { data, count, extendedCardType, compact, compactCardType, noResultsInfo } = props;
    const SpecificCompactWorkHeader = compactCardType === null || compactCardType === void 0 ? void 0 : compactCardType.headerType;
    return (react_1.default.createElement("section", { className: 'items-container' },
        compact && SpecificCompactWorkHeader && react_1.default.createElement(SpecificCompactWorkHeader, null),
        compact && compactCardType ? (react_1.default.createElement(CardResultsTable_1.default, { data: data, count: count, cardType: compactCardType, noResultsInfo: noResultsInfo })) : (react_1.default.createElement(CardResultsTable_1.default, { data: data, count: count, cardType: extendedCardType, noResultsInfo: noResultsInfo }))));
};
exports.default = ExtendedOrCompactCardResults;
